module.exports = __webpack_public_path__ + "img/resized952016062595130414_1.c65f62f9.jpg";